export enum BaseStatus {
  Yes = 'Yes',
  No = 'No',
}

export enum KeyCode {
  Tab = 9,
  Enter = 13,
  Esc = 27,
  Backspace = 8,
  ArrowUp = 38,
  ArrowDown = 40,
  ArrowLeft = 37,
  ArrowRight = 39,
  I = 73,
}

export enum KeyName {
  Tab = 'Tab',
  Enter = 'Enter',
  Esc = 'Escape',
  Backspace = 'Backspace',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
}

export enum State {
  AL = 'AL',
  AK = 'AK',
  AZ = 'AZ',
  AR = 'AR',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  DC = 'DC',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  IA = 'IA',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  ME = 'ME',
  MD = 'MD',
  MA = 'MA',
  MI = 'MI',
  MN = 'MN',
  MS = 'MS',
  MO = 'MO',
  MT = 'MT',
  NE = 'NE',
  NV = 'NV',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NY = 'NY',
  NC = 'NC',
  ND = 'ND',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VT = 'VT',
  VA = 'VA',
  WA = 'WA',
  WV = 'WV',
  WI = 'WI',
  WY = 'WY',
  AE = 'AE',
  AP = 'AP',
  AA = 'AA',
}

export enum HousingType {
  Own = 'Own',
  Rent = 'Rent',
  LivingWithRelative = 'LivingWithRelative',
}

export enum EntityRelationType {
  Array = 'array',
  Object = 'object',
}

export enum DropDownMenuItem {
  Profile = 'Profile',
  LogOut = 'LogOut',
  Login = 'Login',
}

export enum Country {
  USA = 'USA',
}

export enum CountryPhoneCode {
  USA = '1',
  UA = '380',
}

export enum TextType {
  Currency = 'Currency',
  Text = 'Text',
  SplitWordsText = 'SplitWordsText',
  Date = 'Date',
  PhoneNumber = 'PhoneNumber',
  SSN = 'SSN',
  SpaceCommaText = 'SpaceCommaText',
  NoneEmpty = 'NoneEmpty',
  Boolean = 'Boolean',
  CurrencyWithTwoDecimalPlaces = 'CurrencyWithTwoDecimalPlaces',
}

export enum HistoryActions {
  Push = 'PUSH',
  Pop = 'POP',
  Replace = 'REPLACE',
}

export enum CompletionPageType {
  ApplicationWithSigning = 'ApplicationWithSigning',
  Application = 'Application',
  ApplicationSubmitted = 'ApplicationSubmitted',
  Signing = 'Signing',
}

export enum EntityChangeType {
  Created = 'Created',
  Updated = 'Updated',
  Refreshed = 'Refreshed',
  Removed = 'Removed',
}

export enum Team {
  AT = 'AT',
  FZ = 'FZ',
  HZ = 'HZ',
  BFG = 'BFG',
}

export enum LeadSourceName {
  RealtorPortal = 'RealtorPortal',
}

export enum EscrowRequirementType {
  NotAllowed = 'NotAllowed',
  Optional = 'Optional',
  Required = 'Required',
}

export enum CreditConsentType {
  General = 'General',
  Impersonalisation = 'Impersonalisation',
}
